import {URLPathname} from 'interfaces';
import {lazy} from 'react';
import {type RouteObject} from 'react-router-dom';
import {ErrorRaiser} from '../containers/views/globalViews/ErrorRaiser';

const PlanListView = lazy(async () => await import('containers/views/globalViews/PlanListView'));
const OptimizationRuns = lazy(async () => await import('containers/views/globalViews/OptimizationRunsView'));
const ConnectionSettings = lazy(async () => await import('containers/views/globalViews/ConnectionSettingsView'));
const OptimizationRun = lazy(async () => await import('containers/views/globalViews/OptimizationRunView'));
const HarvestReportsView = lazy(async () => await import('containers/views/globalViews/HarvestReportsView'));
const PlanSynchronization = lazy(async () => await import('components/Synchronization/Synchronization'));

export const baseRoutes: RouteObject[] = [
  {
    path: URLPathname.root,
    element: <PlanListView />,
  },
  {
    path: URLPathname.optimizationRuns,
    element: <OptimizationRuns />,
  },
  {
    path: URLPathname.connectionsSettings,
    element: <ConnectionSettings />,
  },
  {
    path: URLPathname.optimizationRunDetail,
    element: <OptimizationRun />,
  },
  {
    path: URLPathname.harvestReports,
    element: <HarvestReportsView />,
  },
  {
    path: URLPathname.error,
    element: <ErrorRaiser />,
  },
  {
    path: URLPathname.planSynchronization,
    element: <PlanSynchronization />,
  },
];
